import React from 'react';
import { graphql, compose } from 'react-apollo';
import { branch, renderComponent, mapProps } from 'recompose';
import { listAssessments } from 'graphql/operations';
import { NETWORK_ONLY } from 'graphql/fetchPolicies';
import { getAssessments } from 'selectors/assessments/selector';
import LoadingPage from 'components/common/Loader/Spinner/Spinner';
import { CustomerRequests } from 'pages/CustomerRequests/CustomerRequests';
import { CompanyRequests } from 'pages/CompanyRequests/CompanyRequests';

export const HomeBase = props => {
  const { assessments } = props;

  const customerAssessments = assessments.filter(assessment => {
    return !assessment.productIdentifier || assessment.productIdentifier === 'E4V';
  });
  // const companyAssessments = assessments.filter(assessment => {
  //   return assessment.productIdentifier === 'E4BU';
  // });

  let homepage = <CustomerRequests />;
  if (!customerAssessments.length) {
    homepage = <CompanyRequests />;
    // if (!companyAssessments.length) {
    //   // Go to some sort of "Nothing Found" messaging...
    // }
  }
  return homepage;
};

export const HomeHOC = compose(
  graphql(listAssessments, { options: { fetchPolicy: NETWORK_ONLY } }),
  mapProps(props => ({
    assessments: getAssessments(props)
  })),
  branch(
    ({ isLoading }) => isLoading,
    renderComponent(() => <LoadingPage size="lg" expanded />)
  )
);

export const Home = HomeHOC(HomeBase);
